import { Component, inject, Input, ViewChild } from '@angular/core';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: '[app-nav-tasks]',
  template: `
    <li><button #tasks routerLink="/maintenances/tasks" *ngIf="authService.hasPermission('can_read_tasks')" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Tareas</button></li>
    <li><button #maintenances routerLink="/maintenances" *ngIf="authService.hasPermission('can_read_tasks')" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Calendario</button></li>
    <li><button #technicians routerLink="/technicians" *ngIf="authService.hasPermission('can_read_technicians')" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Técnicos</button></li>
    <li><button #holidays routerLink="/maintenances/holidays" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Días festivos</button></li>
    <li><button #builders routerLink="/maintenances/builders" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Constructor</button></li>
  `,
  styles: ``
})
export class NavTasksComponent {
  @Input() currentView: string | null = null;
  profile: any = {};
  permissions: any = {};
  @ViewChild('tasks') tasks !: any;
  @ViewChild('maintenances') maintenances !: any;
  @ViewChild('technicians') technicians !: any;
  @ViewChild('holidays') holidays !: any;
  @ViewChild('builders') builders !: any;
  storageService = inject(StorageService);
  constructor(
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  ngAfterViewInit() {
    if (!this.currentView) return;
    
    // Reset all active classes first
    this.resetActiveClasses();
    
    // Only set active class on the current view if the element exists
    switch (this.currentView) {
      case 'tasks':
        if (this.tasks) this.tasks.nativeElement.classList.add('active');
        break;
      case 'maintenances':
        if (this.maintenances) this.maintenances.nativeElement.classList.add('active');
        break;
      case 'technicians':
        if (this.technicians) this.technicians.nativeElement.classList.add('active');
        break;
      case 'holidays':
        if (this.holidays) this.holidays.nativeElement.classList.add('active');
        break;
      case 'builders':
        if (this.builders) this.builders.nativeElement.classList.add('active');
        break;
    }
  }
  
  // Helper method to safely remove active class from all buttons
  private resetActiveClasses() {
    if (this.tasks) this.tasks.nativeElement.classList.remove('active');
    if (this.maintenances) this.maintenances.nativeElement.classList.remove('active');
    if (this.technicians) this.technicians.nativeElement.classList.remove('active');
    if (this.holidays) this.holidays.nativeElement.classList.remove('active');
    if (this.builders) this.builders.nativeElement.classList.remove('active');
  }
}
